const MuiPaper = {
  borderRadius: '20px',
  root: {
    borderRadius: '20px',
    // padding: 20,
  },
}

export default MuiPaper
